import React from 'react';
import { ActionButton } from '@klp/design/Action';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@klp/design/Tooltip';
import type { Aktivitet } from '../interfaces';

import { useCurrentUser } from '@klp/auth';
import { useFormAuth } from '@klp/formgenerator/hooks';
import { Block, Typography } from '@klp/design';
import { Alert } from '@material-ui/lab';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import type { Theme } from '@material-ui/core';
import { getLocalizedRoles } from '../utils';

type FormContainerFieldCompleteProps = {
    isDisabled: boolean;
    isLoading: boolean;
    activity: Aktivitet;
};

const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2),
    },
});

export const FormContainerFieldComplete: React.FC<
    FormContainerFieldCompleteProps
> = ({ isDisabled, isLoading, activity }) => {
    const { t } = useTranslation();
    const classes = useKlpStyles({}, styles);
    const { currentUser } = useCurrentUser();
    const { hasCurrentUserSubmitPrivileges } = useFormAuth();

    const isSubmitDisabled =
        isDisabled ||
        !hasCurrentUserSubmitPrivileges(activity.kandidatGruppeEier);
    const showSubmitDisableWarning =
        !isDisabled &&
        !hasCurrentUserSubmitPrivileges(activity.kandidatGruppeEier);

    return (
        <>
            <div className={classes.container}>
                <Tooltip
                    title={t('prosjekt.notAllowedToPerformAction')}
                    hideTooltip={!isSubmitDisabled}
                >
                    <ActionButton
                        disabled={isSubmitDisabled}
                        isLoading={isLoading}
                        type="submit"
                        actionType="save"
                        translation="formGenerator.submit"
                    />
                </Tooltip>
            </div>
            {showSubmitDisableWarning && (
                <Block paddingVertical="compact">
                    <Alert severity="warning">
                        <Typography>
                            {t('prosjekt.notCandidateGroupOwner', {
                                owner: getLocalizedRoles(
                                    activity.kandidatGruppeEier,
                                ),
                                userRoles: getLocalizedRoles(
                                    currentUser?.roller
                                        .map((r) => r.rolle)
                                        .join(', '),
                                ),
                            })}
                        </Typography>
                    </Alert>
                </Block>
            )}
        </>
    );
};
